export default __webpack_public_path__ + "static/media/croptop-small-right.69b9056c.jpg";